import {Icon, icon} from '@hm/fundamental'
import React, {ReactNode} from 'react'

import {InstructionStatus, InstructionType} from '../types/documents.types'

export const SUPPORTED_DOCUMENTS_FORMAT = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx'
export const INSTRUCTIONS_TENANT_ID = 'shiftHandover'
export const INSTRUCTIONS_SEARCH_QUERY_KEY = 'instructions-search'

export const DOCUMENT_ICON_MAP: Record<InstructionType, ReactNode> = {
  [InstructionType.LINK]: <Icon path={icon.mdiOpenInNew} customSize="1em" />,
  [InstructionType.PDF]: <Icon path={icon.mdiFileDocumentOutline} customSize="1em" />
}

export const STATUS_ICON_MAP: Record<InstructionStatus, ReactNode> = {
  [InstructionStatus.ACTIVE]: (
    <Icon path={icon.mdiCheck} size="regular" className="text-positive" />
  ),
  [InstructionStatus.UPCOMING]: (
    <Icon path={icon.mdiTimerSandEmpty} size="regular" className="text-foreground_faded" />
  ),
  [InstructionStatus.EXPIRED]: (
    <Icon path={icon.mdiClose} size="regular" className="text-negative" />
  )
}

export const STATUS_TRANSLATION_KEY_MAP: Record<InstructionStatus, string> = {
  [InstructionStatus.ACTIVE]: 'documents.statuses.active',
  [InstructionStatus.UPCOMING]: 'documents.statuses.upcoming',
  [InstructionStatus.EXPIRED]: 'documents.statuses.expired'
}

export const MIME_TYPE: Record<string, string> = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
}

export const ATTACHMENT_ID = 0
